import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";

import { Translate, Localize, translate } from "react-i18nify";

import { Button, Grid, Typography, IconButton, TextField } from "@mui/material";

import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";

import CircleButton from "./../Buttons/CircleButton";

import "react-phone-number-input/style.css";

import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal_V";

let env = require("./../../../../env");

// props has activeStep
export default function ConfirmWidget({
  hideConfirmDialog,
  isThisCorrectStyle = {},
  next,
  descText,
  targetText
}) {
  const { customerFirstName, customerLastName } = useContext(KioskContext);

  const kioskstyles = useKioskVerticalStyles();

  return (
    <>
      <div
        id="space_div_and_buttons"
        style={{
          width: "100%",
          height: "39.8vh"
        }}
      >
        <div
          style={{
            marginBottom: "0px",
            width: "100%"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <div style={kioskstyles.blackCornedDivReturningContainer}>
              <Typography
                variant="h5"
                style={{
                  textAlign: "center",
                  fontSize: "2.5vh"
                }}
              >
                {descText}
              </Typography>
              <div style={{ fontSize: "1.3vh" }}>
                <br />
              </div>
              <Typography
                variant="h4"
                style={{
                  textAlign: "center",
                  fontSize: "3vh"
                }}
              >
                {targetText}
              </Typography>
            </div>
          </div>
        </div>
        <div>
          <div
            style={{
              marginTop: "4.8vh",
              marginBottom: "2vh",
              textAlign: "center"
            }}
          >
            <span
              class="fontBold"
              style={{
                fontSize: "3vh",
                ...isThisCorrectStyle
              }}
            >
              <Translate value="application.theme.telephoneIsThisCorrectText" />
            </span>
          </div>
          <div
            key={"telephoneButRow4"}
            style={{
              marginTop: "2vh",
              marginBottom: "1vh",
              display: "flex",
              justifyContent: "center",
              gap: "1vh"
            }}
          >
            <CircleButton
              PercentSize="10%"
              onClick={hideConfirmDialog}
              color="error"
            >
              <div style={{ fontSize: "2.4vh" }}>
                <Translate value="application.theme.noText" />
              </div>
            </CircleButton>
            <div style={{ marginLeft: "60px" }} />
            <CircleButton onClick={next} PercentSize="10%" color="success">
              <div style={{ fontSize: "2.4vh" }}>
                <Translate value="application.theme.yesText" />
              </div>
            </CircleButton>
          </div>
          <div
            id="phoneerror_spacer"
            style={{
              color: "red",
              fontSize: "2.1vh",
              width: "100%",
              height: "2.1vh",
              textAlign: "center"
            }}
          ></div>
        </div>
      </div>
    </>
  );
}
